import React from 'react'
import { clsx } from 'clsx'

export function Tabs({ activeIndex, setActiveIndex, children }) {
  return (
    <>
      <div className="tabs-container">
        <div className="tabs-header">
          {React.Children.map(children, (child, index) => (
            <button
              className={clsx('tab-button', activeIndex === index && 'active')}
              onClick={() => setActiveIndex(index)}
            >
              {child.props.label}
            </button>
          ))}
        </div>
        <div className="tabs-content">{React.Children.toArray(children)[activeIndex]}</div>
      </div>
    </>
  )
}

export function TabPanel({ children }) {
  return (
    <>
      <div className="tab-panel">{children}</div>
    </>
  )
}
